//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { commonTool, numberTool } from '@/util/tool'
import { fileutil } from '@/util/fileutil'
import moment from 'moment'
import areaCascader from '@/pages/common/areaCascader/areaCascader'
import { Toast } from 'vant';
import store from '@/store'
export default {
  data () {
    return {
      userInfo: this.$store.getters.getUserInfo,
      isHaveproject:'0',
      companyId: '-1',
      selectProjectInfo:[],
      projectId: '-1',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      timeFlag: false,
      visible: false,
      confirmLoading: false,
      commonTool,
      previewVisible: false,
      previewImage: '',
      form: {
        sysProdTypeId: '',
        needMark: '',
        lastTime: '',
        budgetMoney: '',
        address: '',
        checkPermission: [],
        detailAddress: '',
        title: '',
        userPhone: '',
        password: '',
        linkType: '-1',
        projectId: '',
        companyId: '',
        linkStr: ''
      },
      rules: {
        title: [{required: true, message: '请填写标题'},{max: 30, message: '标题长度不能超过30'}],
        sysProdTypeId: [{required: true, message: '请选择产品分类'}],
        needMark: [{required: true, message: '请填写您的供应'}, {max: 200, message: '内容长度不能超过200'}],
        fileList: [{required: false}],
        budgetMoney: [{required: false}],
        address: [{required: true, message: '请选择省市区'}],
        detailAddress: [{required: true, message: '请填写地址'}],
        lastTime: [{required: true, message: '请选择供需截止时间'}],
        userPhone: [{required: this.userInfo == null || this.userInfo.id == null, message: '请输入手机号'}],
        password: [{required: this.userInfo == null || this.userInfo.id == null, message: '请输入验证码'}],
        linkType: [{required: false,message: '请选择供应跳转链接类型'}],
        projectId: [{required: this.flagPro,message: '请选择关联产品方案'}],
        linkStr:[{required: this.flagStr,validator: this.linkCheck}],
        companyId:[{required: true,message: '请选择服务商'}],
        checkPermission: [{
          type: 'array',
          required: true,
          message: '请勾选服务协议和隐私保护政策',
          trigger: 'change',
        }]
      },
      flagPro:false,
      flagStr:false,
      sysProdTypes: [],
      fileList: [],
      fileutil,
      moment,
      fileGroupId: commonTool.generateUUID(),
      timer: null,
      second: 59,
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId :  window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      companyList:[],

    }
  },
  components: {
    areaCascader
  },
  methods: {
    linkCheck (rule, value, callback) {
      if (this.isHaveproject == 2) {
        var http = /^http:\/\/.*/i.test(this.form.linkStr)
        var https = /^https:\/\/.*/i.test(this.form.linkStr)
        if (!http && !https) {
          callback(new Error('链接格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    showForm (userInfo,demandInfo,societyId) {
      this.isHaveproject = 0
      this.userInfo = userInfo
      // this.companyId = '-1'
      this.visible = true
      this.initSysProd()
      this.fnInitProjectInfo()
      this.$nextTick(() => {
        if (demandInfo) {
          this.form.sysProdTypeId = demandInfo.sysProdTypeId
        }
      })
      if(societyId != null && societyId != '' && societyId != undefined){
        this.societyId = societyId;
      }
    },
    checkInputMoney (e) {
      this.form.budgetMoney = commonTool.validateFields_money_limit_7_2(e)
    },
    changeLinkType (value) {
      if (value == 1) {
        this.flagPro = true
      }
      if (value == 2) {
        this.flagStr = true
      }
      this.isHaveproject = value
    },
    fnInitProjectInfo () {
      // var params = { companyId: this.userInfo.companyId }
      console.log(this.userInfo)
      var list = this.userInfo.ccUserBoList
      if (list.length == 0) {
        Toast("非企业用户，不能发布供应")
        this.sloce()
        return
      // }
      //  // else if(list.length == 1){
      //   this.companyList = []
      //   list.forEach(val =>{
      //     val.key = val.id
      //     val.lable = val.companyName;
      //     this.companyList.push(val)

      //   })
      }else {
        // 根据机构id和企业id数字，去数据库中获取对应企业加入机构的时候的名称
        this.selCompanyList(this.societyId, this.userInfo.id)

        // list.forEach(val =>{
        //   let societyIdList = val.societyIdList;
        //   if(this.societyId != null && this.societyId != '' ){
        //     if(societyIdList != null && societyIdList.length > 0 && societyIdList.indexOf(this.societyId) > -1){
        //       // val.key = val.id
        //       // val.lable = val.companyName
        //       // this.companyList.push(val)
        //     }
        //   }else{
        //     val.key = val.id
        //     val.lable = val.companyName;
        //     this.companyList.push(val)
        //   }
        // })
      }

      // this.$store.dispatch('ccProjectInfo/selCcProjectInfoByCompanyId', JSON.stringify(params)).then(res => {
      //   console.log(res)
      //   this.selectProjectInfo = res.data.objs
      // }).catch(function (error) {
      //   msgTool.messageError(this, error)
      // }.bind(this))
    },
    selCompanyList (societyId, userId) {
      this.companyList = []
      var params = { societyId: societyId,ucUserId: userId  }
      this.$store.dispatch('ccCompanySupplyDemand/selCompanyListByUserIdAndSocietyId', JSON.stringify(params)).then(res => {
        console.log(res)
        res.data.objs.forEach(val =>{
          val.key = val.id
          val.companyId = val.id
          val.lable = val.companyName;
          this.companyList.push(val)

        })
      }).catch(function (error) {
        msgTool.messageError(this, error)
      }.bind(this))
    },
    selProjectInfo (value) {
      this.companyId = value
      var params = { companyId: value }
      this.$store.dispatch('ccProjectInfo/selCcProjectInfoByCompanyId', JSON.stringify(params)).then(res => {
        console.log(res)
        this.selectProjectInfo = res.data.objs
      }).catch(function (error) {
        msgTool.messageError(this, error)
      }.bind(this))
    },
    initSysProd() {
      const param = {}
      this.$store.dispatch('sysProdType/querySysProdType', JSON.stringify(param))
        .then(res => {
          this.sysProdTypes = []
          if (res.data.retCode == 1) {
            res.data.objs.forEach(type => {
              type.key = type.id
              type.label = type.name
              if (type.children) {
                type.children.forEach(c => {
                  c.key = c.id
                  c.label = c.name
                })
              }
              this.sysProdTypes.push(type)
            })
            console.log('this.sysProdTypes===>', this.sysProdTypes)
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleFileChange(info) {
      const status = info.file.status
      // 格式不对的文件不显示在文件列表中
      if (status) {
        const fileList = [...info.fileList]
        this.fileList = fileList
      }
      if (this.fileList.length>6) {
        const fileList = [...info.fileList]
        this.fileList = fileList.splice(-6)
      }
      if (status === 'done') {
        console.log(JSON.stringify(info.file.response.obj))
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    beforeUpload(file) {
      return fileutil.beforeUpload(this, file)
    },
    fileValidate(rule, value, callback) {
      if (this.fileList == 0) {
        callback(new Error('请上传附件')); // 校验不通过结束当前校验
        return false
      } else {
        callback()
      }
    },
    fnRemove(file) {
    },
    handleCancel() {
      this.visible = false;
      this.previewVisible = false;
    },
    changeAreaData(value) { // 设置地区的值
      this.form.address = value
      this.$refs.form.validateField('address', (error) => {
      });
    },
    sloce() {
      commonTool.move()
      this.visible = false
      this.$refs.form.resetFields()
      this.fileList = []
    },
    fnChangeLastTime(values) {
      if (values == null) {
        this.form.lastTime = null
      } else {
        this.form.lastTime = moment(values).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    fnChangeProdType(params) {
      this.form.sysProdTypeId = params
      this.$refs.form.validateField('sysProdTypeId', (error) => {
      });
    },
    disabledDateTodyBefore(current) {
      return current && moment(current).format('YYYY-MM-DD') < moment(moment().endOf('day')).format('YYYY-MM-DD');
    },
    fnSaveDemand() {
      this.$refs.form.validate((valid, values) => {
        if (valid) {
          if (!this.userInfo || !this.userInfo.id) {
            this.fnDoLogin()
          } else {
            const obj = this.createSaveData()
            obj.ccFileInfoBos = this.createFiles(obj)
            console.log('fnSaveDemand saveObj ===>', obj)
            this.$store.dispatch('ccCompanySupplyDemand/saveCcCompanySupplyDemand', JSON.stringify(obj))
            .then((res) => {
              console.log('fnSaveDemand res===>', res)
              if (res.data.retCode == 1) {
                Toast(res.data.retMsg)
                this.$emit('saveDemandSuccess', obj)
                this.sloce()
              } else{
                Toast(res.data.retMsg)
              }
            }).catch(err => {
              console.log('------------err--------', err)
              console.log(JSON.stringify(err))
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    fnDoLogin () {
      let param = {
        loginType: 0,
        userPhone: this.form.userPhone,
        password: this.form.password,
        createType: 0,
        bindWechar: 0,
        realState: 0,
        safetyLevel: 0,
        isLogin: 0,
        autoRegister: 1
      }
      this.$store.dispatch('user/fnLoginNoCheckDoLogin',JSON.stringify(param)).then(res=>{
        if(res.data.retCode == 1){
          Toast('登录成功')
          this.userInfo = res.data.obj
          this.$store.commit('setUserInfo',this.userInfo)
          this.$emit('lognSucccess', this.userInfo)
          this.fnSaveDemand()
        }else{
          Toast(res.data.retMsg)
        }
      })
    },
    createSaveData() {
      const obj = {}
      obj.societyId = this.societyId
      obj.companyId = this.companyId
      obj.sysProdTypeId = this.form.sysProdTypeId
      this.companyList.forEach(val => {
        if (val.companyId == this.companyId){
          obj.companyUserId = val.id
          obj.appId = val.useAppId
          return false
        }
      })
      obj.userId = this.userInfo.id
      this.sysProdTypes.every(type => {
        var child = type.children.find(c => c.id == this.form.sysProdTypeId)
        if (child) {
          obj.sysProdTypeName = child.name
          return false
        }
        return true
      })
      obj.title = this.form.title
      obj.remark = this.form.needMark
      obj.fileGroupId = this.fileGroupId
      obj.country = '中华人民共和国'
      obj.province = this.form.address.province
      obj.city = this.form.address.city
      obj.area = this.form.address.district
      obj.countryCode = '-1'
      obj.provinceCode = this.form.address.provinceCode
      obj.cityCode = this.form.address.cityCode
      obj.areaCode = this.form.address.districtCode
      obj.address = this.form.detailAddress
      obj.money = numberTool.numMulti(this.form.budgetMoney, 100)
      obj.delState = 0
      obj.linkType = this.form.linkType
      obj.linkStr = this.form.linkStr
      obj.projectId = this.form.projectId
      obj.releaseState = 1
      return obj
    },
    createFiles(data) {
      const arr = []
      this.fileList.forEach(file => {
        const item = file.response.obj
        const obj = {}
        obj.companyId = this.companyId
        obj.appId = data.appId
        obj.groupId = this.fileGroupId
        obj.url = item.url
        obj.disLocal = item.url
        obj.zipUrl = item.url
        obj.zipDisLocal = item.urlqueryParam
        obj.fileSource = '00007'
        obj.fixName = item.fileType
        obj.fileType = commonTool.getFileType(obj.fixName)
        obj.fileName = item.fileName
        obj.userId = this.userInfo.id
        obj.sort = 1
        obj.isUse = 1
        arr.push(obj)
      });
      return arr
    },
    getToken () {
      return store.getters.getToken
    },
    fnSendSms() { // 发送验证码
      if(this.form.userPhone == ''){
        Toast('请输入手机号')
        return
      }
      let param = {
          smsType: 0,
          smsPhone: this.form.userPhone
      }
      let checkParam = {
        userPhone: this.form.userPhone,
      };
      // 调用发验证码接口
      this.$store.dispatch('fnNoCheckSmsSendSmsCode',JSON.stringify(param)).then(res=>{
        if(res.data.retCode == 1){
          this.fnHandleTimer()
        }else{
          Toast(res.data.retMsg)
        }
      })
    },
    fnHandleTimer() { // 处理验证码
      let maxSecond = 60
      this.timeFlag = true
      this.timer = setInterval(() => {
       if (this.second > 0 && this.second <= maxSecond) {
         this.second--
        } else {
         this.timeFlag = false
         this.second = 59
         clearInterval(this.timer)
        }
       }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/supplyDemandAddForm.vue